export default "__VITE_ASSET__C4Xo1aSa__"